import React, { FC } from 'react';
import { InventoryStatusCode } from '@/lib/shopify';
import useProductContext from '@/context/ProductContext';
import { TypeProduct } from '@/core/generated-types';

interface InventoryStatusProps {
  inventoryStatus: InventoryStatusCode | null;
  product: {
    fields: Pick<
      TypeProduct['fields'],
      'backOrderMessage' | 'outOfStockMessage'
    >;
  } | null;
  classNames?: {
    wrapper?: string;
    outOfStock?: string;
    backOrder?: string;
    preSale?: string;
  };
}

const InventoryStatus: FC<InventoryStatusProps> = ({
  inventoryStatus,
  product,
  classNames,
}) => {
  const { inventoryStatusCopy } = useProductContext();
  const { backOrderMessage, outOfStockMessage } = {
    ...product?.fields,
  };

  let message = null;
  let statusClassName = '';

  switch (inventoryStatus) {
    case InventoryStatusCode.OUT_OF_STOCK:
      message = outOfStockMessage || inventoryStatusCopy?.outOfStock;
      statusClassName = classNames?.outOfStock ?? 'text-red';
      break;

    case InventoryStatusCode.BACKORDER:
      message = backOrderMessage || inventoryStatusCopy?.backOrder;
      statusClassName = classNames?.backOrder ?? 'text-charcoal';
      break;

    case InventoryStatusCode.PRESALE:
      message = inventoryStatusCopy?.preSale;
      statusClassName = classNames?.preSale ?? 'text-success';
      break;

    default:
      return null;
  }

  const combinedClassName = [classNames?.wrapper, statusClassName]
    .filter(Boolean)
    .join(' ');

  return message ? <span className={combinedClassName}>{message}</span> : null;
};

export default InventoryStatus;
